module.exports = __webpack_public_path__ + "8aaf7b07a095d63dad570b7667bf57b8.jpg";